import PropTypes from 'prop-types'
import styled from 'styled-components'
import { t, jt } from 'ttag'

import { features } from '@h2/components/media'
import { SY90T, WHITE } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Heading } from '@h2/components/typography/heading'
import { PromoButton } from '@h2/components/buttons/promo'
import { Checklist as ChecklistComponent } from '@h2/components/containers/checklist'
import { vagRundFont } from '@h2/components/mixins'
import educatorPlusSvg from '@h2/assets/svg/home/educatorPlus.svg'
import educatorPlusBgSvg from '@h2/assets/svg/home/educatorPlusBg.svg'
import { Panel as PanelComponent } from '@h2/common/components/panel'

const allStudents = <span key="students">{t`all the students`}</span>
const shareData = <span key="share">{t`Share data`}</span>
const singleSignOn = <span key="sso">{t`Single Sign On`}</span>
const advancedFunctionality = <span key="advanced">{t`Advanced Functionality`}</span>
const Checklist = styled(ChecklistComponent)`
  ${vagRundFont};
  font-weight: 300;

  li {
    padding-left: 30px;
    margin-bottom: 8px;

    span > span {
      font-weight: 400;
    }
  }
`
const Panel = styled(PanelComponent)`
  @media (${features.minWidth.desktop}) {
    background-color: ${WHITE};
    margin-bottom: 50px;
  }
`
const InnerFlex = styled(Flex)`
  @media (${features.minWidth.desktop}) {
    flex-direction: row;
    align-items: center;
    width: 100%;

    > div:first-child {
      padding: 0;
      margin: 0 28px;

      ul {
        display: flex;
        flex-wrap: wrap;
        width: 530px;

        li {
          width: max-content;
          margin: 0;
        }

        li:first-child {
          order: 1;
          flex-grow: 0.36;
          margin-bottom: 8px;
        }

        li:nth-child(2) {
          order: 3;
          flex-grow: 1;
        }

        li:nth-child(3) {
          order: 2;
          margin-bottom: 8px;
        }

        li:nth-child(4) {
          order: 4;
        }
      }
    }

    > div:last-child {
      width: 239px;
    }

    @media (${features.maxWidth.widescreen}) {
      justify-content: space-between;

      > div:first-child {
        margin: 0;
      }

      > div:last-child {
        position: relative;
        top: -18px;
      }
    }
  }
`
const FlexWrap = styled(Flex)`
  background-image: url('${educatorPlusSvg}'), url('${educatorPlusBgSvg}');
  background-repeat: no-repeat;
  background-position: left top;
  background-origin: content-box;
  background-size: 187px auto, cover;

  h3 {
    font-size: 26px;
    line-height: 28px;
  }

  @media (${features.minWidth.desktop}) {
    flex-direction: row;
    align-items: center;
    padding: 15px;
    background-position: left bottom;
    background-origin: padding-box;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;

    > div:first-child {
      padding-left: 90px;
      width: 285px;
      min-width: 285px;
    }

    @media (${features.maxWidth.widescreen}) {
      flex-direction: column;
      align-items: normal;
      padding-left: 110px;

      > div:first-child {
        padding-left: 0;
        width: auto;
        margin-bottom: 10px;
      }
    }
  }
`
const SchoolNeeds = ({ subscriptionPage }) => {
  return (
    <Panel color={SY90T}>
      <FlexWrap direction="column" padding="25px 20px">
        <Box padding="0 0 0 110px" width="310px">
          <Heading level="3" removeMargins>
            {t`Plus, when your school needs to:`}
          </Heading>
        </Box>
        <InnerFlex direction="column">
          <Box padding="40px 5px 25px 5px">
            <Checklist variant="smaller-text">
              <Checklist.Item>{jt`Manage ${allStudents} in a school`}</Checklist.Item>
              <Checklist.Item>{jt`${shareData} between educators`}</Checklist.Item>
              <Checklist.Item>{jt`Integrate ${singleSignOn}`}</Checklist.Item>
              <Checklist.Item>{jt`Unlock ${advancedFunctionality}`}</Checklist.Item>
            </Checklist>
          </Box>
          <Box width="100%">
            <PromoButton
              isFullWidth
              size="large"
              align="center"
              variant="invert-larger-text"
              onClick={() => window.location.assign(subscriptionPage)}>
              {t`Explore our upgrades`}
            </PromoButton>
          </Box>
        </InnerFlex>
      </FlexWrap>
    </Panel>
  )
}

SchoolNeeds.propTypes = {
  subscriptionPage: PropTypes.string.isRequired
}

export { SchoolNeeds }
